function phonePrefixFilter(value: string, search: string): number {
  const trimmedSearch = search.trim();

  if (!trimmedSearch) {
    return 1;
  }

  const [country = '', dialCode = ''] = value.split('+');

  if (/^[a-zA-Z]+$/.test(trimmedSearch)) {
    return country.toLowerCase().startsWith(trimmedSearch.toLowerCase()) ? 1 : 0;
  }

  const searchDigits = trimmedSearch.replace(/\D/g, '');

  return searchDigits && dialCode.includes(searchDigits) ? 1 : 0;
}

export { phonePrefixFilter };
